import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";

import {blueColor} from "assets/jss/main";

ShipmentModalSubtitle.propTypes = {
    orderNumber: PropTypes.string,
    trackingNumber: PropTypes.string
}

function ShipmentModalSubtitle({orderNumber, trackingNumber}) {
    return (
        <div>
            <FormattedMessage id='wms.triShipping.shipmentModal.subtitle' />
            <br/>
            <br/>
            <span style={{
                color: blueColor,
                fontSize: '20px',
                fontWeight: 600
            }}>
                {orderNumber}
            </span>
            <br/>
            <FormattedMessage id='wms.triShipping.trackingNumber' /> <span>#{trackingNumber}</span>
        </div>
    );
}

export default ShipmentModalSubtitle;
